// Instagram.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const Instagram = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    en: "https://www.instagram.com/condesahotel/",
  };

  return (
    <>
      {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
      <button
        className="button-styles hover-text"
        onClick={() => setShowModal(true)}
      >
        <span className="tooltip-text" id="fade">
          Instagram
        </span>
        <i className="bi bi-instagram" />
      </button>
      {showModal && (
        <LanguageModal
          title="Instagram"
          icon="bi bi-instagram"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default Instagram;
